import React from 'react';
import Select, { NonceProvider, } from 'react-select';
export default function MenuSelect({ menuSettings, menu }) {
    const { items, refine } = menu;
    const { attribute, className, classNamePrefix, classNames, inputId, styles, translations, isClearable, isSearchable, unstyled, menuIsOpen, components, getOptionLabel, nonce, cacheKey, } = menuSettings;
    const selectedValue = items.filter((item) => item.isRefined) || [];
    const props = {
        unstyled,
        menuIsOpen,
    };
    if (unstyled) {
        props.unstyled = true;
    }
    if (menuIsOpen) {
        props.menuIsOpen = true;
    }
    return (React.createElement(NonceProvider, { nonce: nonce || '', cacheKey: cacheKey || attribute.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/[\s_]+/g, '-').toLowerCase() },
        React.createElement(Select
        /* eslint-disable react/jsx-props-no-spreading */
        , Object.assign({}, props, { className: className, classNamePrefix: classNamePrefix || 'menu-select', classNames: classNames, inputId: inputId, styles: styles, isClearable: isClearable || false, isSearchable: isSearchable || false, placeholder: (translations === null || translations === void 0 ? void 0 : translations.defaultOptionText) || 'See all options', noOptionsMessage: () => ((translations === null || translations === void 0 ? void 0 : translations.noOptionsMessage) || 'No options'), options: items, value: selectedValue, onChange: (option) => {
                const selectedOption = option ? option : null;
                const value = selectedOption ? selectedOption.value : '';
                refine(value);
            }, getOptionLabel: getOptionLabel || ((option) => {
                const item = option ? option : null;
                return `${item === null || item === void 0 ? void 0 : item.label} (${item === null || item === void 0 ? void 0 : item.count})`;
            }), components: components }))));
}
